import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useRouter } from 'next/router';
import pagination from '@culture/common-helpers/pagination';

import NextLink from 'components/NextLink';

import styles from './styles.module.scss';

const Pagination = ({ total, current, delta }) => {
	const pages = pagination(current, total, delta);
	const { query, pathname } = useRouter();

	return (
		<div className={styles.Pagination} data-cy="pagination-container">
			{pages.map((page, index) =>
				page ? (
					<NextLink
						key={page}
						className={cx(styles.Pagination__Link, {
							[styles.Pagination__Link_active]: page === current
						})}
						href={{ pathname, query: { ...query, page } }}
						next
					>
						<span className={styles.Pagination__ScreenreaderText}>
							Страница {page}
						</span>
						<span aria-hidden="true">{page}</span>
					</NextLink>
				) : (
					<div
						// eslint-disable-next-line react/no-array-index-key
						key={`dots-${index}`}
						className={styles.Pagination__Dots}
						data-cy="three-dots"
					>
						<span className={styles.Pagination__Dot} />
						<span className={styles.Pagination__Dot} />
						<span className={styles.Pagination__Dot} />
					</div>
				)
			)}
		</div>
	);
};

Pagination.propTypes = {
	total: PropTypes.number.isRequired,
	current: PropTypes.number.isRequired,
	delta: PropTypes.number
};

Pagination.defaultProps = {
	delta: 1
};

export default Pagination;
